import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import Challenge from '../../challenge';
import type { LoginChallengeProps } from '../login-challenge';
import PhoneKbaChallenge from './phone-kba-challenge';
enum Screen {
  kba = 'kba',
  challenge = 'challenge',
}
type LoginWithUnverifiedEmailProps = Omit<LoginChallengeProps, 'onReset'> & {
  onPrev: () => void;
};
const LoginWithUnverifiedEmail = t0 => {
  const $ = _c(13);
  const {
    context,
    requirement,
    onDone,
    onPrev
  } = t0;
  const [screen, setScreen] = useState(Screen.kba);
  if (screen === Screen.kba) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = () => {
        setScreen(Screen.challenge);
      };
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] !== context || $[2] !== onPrev || $[3] !== requirement) {
      t2 = <PhoneKbaChallenge requirement={requirement} context={context} onPrev={onPrev} onSuccess={t1} />;
      $[1] = context;
      $[2] = onPrev;
      $[3] = requirement;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  const t1 = context.state.email?.value;
  const t2 = context.state.phoneNumber?.value;
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = {
      email: t1,
      phoneNumber: t2
    };
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setScreen(Screen.kba);
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== context || $[10] !== onDone || $[11] !== t3) {
    t5 = <Challenge defaultValues={t3} context={context} onDone={onDone} onPrev={t4} onError={context.onError} challengeKind="email" />;
    $[9] = context;
    $[10] = onDone;
    $[11] = t3;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export default LoginWithUnverifiedEmail;